import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import Header from '../../components/header';
import Card from '../../components/Card';
import Sidebar from '../../components/sidebar/sidebar';
import AboutDefatom from './AboutDefatom';

const GuideAndSupport = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [activeTab, setActiveTab] = useState<'About' | 'Guide' | 'Support'>('About');
  const navigate = useNavigate();

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className="bg-[var(--Background-Color,#161617)] flex-1">
        <Header title="Support" dropdown={2} />
        <Card className="flex-1">
          <div className="flex items-center justify-between mb-4">
            {/* Title */}
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
              {['About', 'Guide', 'Support'].map((tab) => (
                <button
                  key={tab}
                  onClick={() => {
                    setActiveTab(tab as 'About' | 'Guide' | 'Support');
                    if (tab === 'Guide') {
                      navigate('/GuideAndSupport/Guide');
                    }
                    if (tab === 'Support') {
                      navigate('/GuideAndSupport/Support');
                    }
                  }}
                  style={{
                    padding: '0.5rem 1rem',
                    borderRadius: '6px',
                    borderRight: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
                    borderLeft: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
                    color: '#fff',
                    cursor: 'pointer',
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
          <AboutDefatom />
        </Card>
      </div>
    </div>
  );
};

export default GuideAndSupport;
